@if (loading) {
    <cb-loading-spinner message="Please wait loading.." class="cb-margin"> </cb-loading-spinner>
}
@if (
    !loading &&
    (quantityAccount == null ||
        quantityAccount?.buildStages == null ||
        quantityAccount?.buildStages?.length == 0)
) {
    <cb-info-message
        message="There are no Confirmed Quantities for this Lot"
        icon="info_circle"
        class="cb-margin"
    ></cb-info-message>
}
@if (!loading && quantityAccount?.buildStages?.length) {
    <div style="margin-bottom: 0" class="top-panel cb-margin end-center flex-row">
        <button
            class="cb-margin-left"
            mat-raised-button
            color="primary"
            (click)="expandCollapseAll()"
        >
            @if (!allExpanded) {
                <span class="start-center flex-row">
                    <span>Expand All&nbsp;</span>
                    <mat-icon>keyboard_arrow_down</mat-icon>
                </span>
            }
            @if (allExpanded) {
                <span class="start-center flex-row">
                    <span>Collapse All&nbsp;</span>
                    <mat-icon>keyboard_arrow_up</mat-icon>
                </span>
            }
        </button>
    </div>
    <mat-accordion [multi]="true" class="accordion cb-padding-bottom">
        @for (stage of quantityAccount?.buildStages; track stage) {
            <mat-expansion-panel
                class="panel"
                [(expanded)]="expandedAreas['stage' + stage?.id]"
                (expandedChange)="expandedChange()"
            >
                <mat-expansion-panel-header class="cb-padding-top cb-padding-bottom">
                    <mat-panel-title>
                        <span class="mat-body-strong cb-margin-top">
                            {{ stage?.label }}&nbsp;({{ stage?.buildActivities?.length }})
                        </span>
                    </mat-panel-title>
                    <mat-panel-description class="end-center flex-row"> </mat-panel-description>
                </mat-expansion-panel-header>
                @for (activity of stage?.buildActivities; track activity) {
                    <div class="flex-col">
                        <span class="mat-body-strong">
                            @if (activity.notes) {
                                <mat-icon
                                    class="mat-accent help-cursor"
                                    title="{{ activity.notes }}"
                                >
                                    insert_drive_file
                                </mat-icon>
                            }
                            &#9;{{ activity.code }} - {{ activity.name
                            }}{{ getCostXName(activity) }}
                        </span>
                        @if ($any(activity).hasMultipleSuppliers) {
                            <span style="color: red; margin-left: 20px" class="mat-body-strong">
                                <mat-icon class="mat-warn">warning</mat-icon>
                                &nbsp; Activity lines contain multiple Suppliers
                            </span>
                        }
                        <cb-table
                            class="cb-margin-top flex"
                            label="Confirmed Quantities"
                            maxHeightOffset="280"
                            [loaded]="!loading"
                            [results]="stage.buildActivities"
                        >
                            <thead cbTableHead>
                                <tr>
                                    <td></td>
                                    <td>Product ID</td>
                                    <td>Product Name</td>
                                    <td>Supplier</td>
                                    <td>Quantity</td>
                                    <td>UOM</td>
                                    <td>Rate</td>
                                    <td>Subtotal</td>
                                    @if (isTakeOffBudgetsEnabled) {
                                        <td>QS Budget</td>
                                    }
                                    @if (isAiRateSystemEnabled) {
                                        <td class="right-align"></td>
                                    }
                                </tr>
                            </thead>
                            <tbody cbTableBody>
                                @for (item of activity?.takeOffItems; track item) {
                                    <tr>
                                        <td>
                                            @if (item.costType === COST_TYPE_ENUM.DescriptiveOnly) {
                                                <mat-icon fontIcon="notes"> </mat-icon>
                                            }
                                        </td>
                                        <td>
                                            <cb-td-text [value]="item.code"></cb-td-text>
                                        </td>
                                        <td>
                                            <cb-td-text [value]="item.name"></cb-td-text>
                                        </td>
                                        <td>
                                            <cb-td-text [value]="item.supplier"></cb-td-text>
                                        </td>
                                        <td>
                                            <cb-td-text [value]="item.quantity"></cb-td-text>
                                        </td>
                                        <td>
                                            <cb-td-text [value]="item.uom"></cb-td-text>
                                        </td>
                                        <td>
                                            <cb-currency
                                                name="rate"
                                                [ngModel]="item.takeOffRate"
                                                [readonly]="true"
                                            ></cb-currency>
                                        </td>
                                        <td>
                                            <cb-currency
                                                name="subTotal"
                                                [ngModel]="
                                                    calculateSubTotal(
                                                        item.takeOffRate,
                                                        item.quantity
                                                    )
                                                "
                                                [readonly]="true"
                                            ></cb-currency>
                                        </td>
                                        @if (isTakeOffBudgetsEnabled) {
                                            <td>
                                                <cb-currency
                                                    name="budget"
                                                    [ngModel]="item.budget"
                                                    [readonly]="true"
                                                ></cb-currency>
                                            </td>
                                        }
                                        @if (isAiRateSystemEnabled) {
                                            <td class="right-align">
                                                @if (
                                                    item.costType === COST_TYPE_ENUM.Actual &&
                                                    item.offeringId !== 7122
                                                ) {
                                                    <button
                                                        mat-icon-button
                                                        (click)="queryRate(item, activity)"
                                                    >
                                                        <mat-icon
                                                            [matTooltip]="
                                                                'Ask AI about this rate and QS budget'
                                                            "
                                                            >fingerprint</mat-icon
                                                        >
                                                    </button>
                                                }
                                            </td>
                                        }
                                    </tr>
                                }
                                @for (item of activity?.takeOffItems; track item) {
                                    @if (item?.notes) {
                                        <tr>
                                            <td style="width: 30px">
                                                <mat-icon class="cb-small-icon"
                                                    >insert_drive_file</mat-icon
                                                >
                                            </td>
                                            <td></td>
                                            <td>
                                                <span class="mat-body-2 preserve-line-breaks">{{
                                                    item.notes
                                                }}</span>
                                            </td>
                                            <td colspan="5"></td>
                                            @if (isTakeOffBudgetsEnabled) {
                                                <td></td>
                                            }
                                            @if (isAiRateSystemEnabled) {
                                                <td></td>
                                            }
                                        </tr>
                                    }
                                }
                                <tr>
                                    <td colspan="7"></td>
                                    <td class="mat-body-strong">
                                        <cb-currency
                                            name="activitySubtotal"
                                            [ngModel]="activity?.subtotal"
                                            [readonly]="true"
                                        ></cb-currency>
                                    </td>
                                    @if (isTakeOffBudgetsEnabled) {
                                        <td class="mat-body-strong">
                                            <cb-currency
                                                name="budgetSubtotal"
                                                [ngModel]="
                                                    getBudgetTotalsForTakeoffItems(
                                                        activity?.takeOffItems
                                                    )
                                                "
                                                [readonly]="true"
                                            ></cb-currency>
                                        </td>
                                    }
                                    @if (isAiRateSystemEnabled) {
                                        <td></td>
                                    }
                                </tr>
                                @if (activity?.costXGroupName?.length > 0) {
                                    <tr>
                                        <td colspan="7" style="font-style: italic">
                                            Split Activity Subtotal
                                        </td>
                                        <td class="mat-body-strong" style="font-style: italic">
                                            <cb-currency
                                                name="costXGroupSubtotal"
                                                [ngModel]="activity?.costXGroupSubtotal"
                                                [readonly]="true"
                                            ></cb-currency>
                                        </td>
                                        @if (isAiRateSystemEnabled) {
                                            <td></td>
                                        }
                                    </tr>
                                }
                            </tbody>
                        </cb-table>
                    </div>
                }
                <div class="cb-margin flex-row">
                    <div class="flex-col flex"></div>
                    <div class="flex-col">
                        <h3>{{ getStageLabel(stage) }}</h3>
                    </div>
                </div>
            </mat-expansion-panel>
        }
    </mat-accordion>
}
